import { cn } from '@/lib/utils';
import { EntityAvatar } from '@/modules/common/components/molecules/avatar/entity-avatar';
import { OpsiumUserShort } from '@/modules/common/types/opsium-user';
import { ScrollableText } from '@/modules/planner/components/assignment/text/scrollable-text';

interface TimeOffEmployeeCellProps {
  employee: OpsiumUserShort;
  isPast: boolean;
}

/** Employee column: avatar + name of the person who requested the time-off. */
export const TimeOffEmployeeCell = ({ employee, isPast }: TimeOffEmployeeCellProps) => (
  <div className={cn('flex min-w-0 items-center gap-2', isPast && 'opacity-50')}>
    <EntityAvatar
      image={employee.profileImageUrl}
      name={employee.name}
      size="md"
      shape="rounded"
      shouldDownscale={false}
    />
    <div className="min-w-0 flex-1 overflow-hidden">
      <ScrollableText className="whitespace-nowrap">{employee.name}</ScrollableText>
    </div>
  </div>
);
